import { useLazyQuery } from '@apollo/client';
import GuestAutoCompleteCustom from './GuestAutoCompleteCustom';
import { GET_GUESTS } from 'operations/queries/queryGuest';
import React, { useMemo } from 'react';

const GuestAutoComplete = ({ guest, ...props }) => {
  const [searchGuest] = useLazyQuery(GET_GUESTS);
  const defaultOption = useMemo(
    () =>
      guest
        ? Array.isArray(guest)
          ? guest.map(({ id, name }) => ({ value: id, label: name }))
          : { value: guest.id, label: guest.name }
        : null,
    [guest]
  );

  return (
    <GuestAutoCompleteCustom
      defaultOption={defaultOption}
      handleSearch={searchGuest}
      labelKey="name"
      valueKey="id"
      dataKey="guests"
      placeholder="Tìm khách mời"
      style={{ width: '100%' }}
      {...props}
    />
  );
};

export default GuestAutoComplete;
